import { ErrorCode, ErrorName } from 'src/constants';

import { ClientServicesLink } from '../ClientServicesLink/ClientServicesLink';
import { MTypography } from '../MTypography/MTypography';

export interface UnknownErrorMessageProps {
  code?: ErrorCode; // TODO: remove code from error response
  name?: string; // TODO: replace name with ErrorName
  message?: string | string[];
  variant?: 'body1' | 'body2' | 'h5';
  weight?: 'light' | 'normal' | 'semibold' | 'bold';
}

export const UnknownErrorMessage = ({
  code,
  name,
  message,
  variant = 'body1',
  weight = 'normal',
}: UnknownErrorMessageProps) => {
  if (name === ErrorName.Network && message) {
    return (
      <MTypography variant={variant} weight={weight}>
        {message}
      </MTypography>
    );
  }

  return (
    <MTypography variant={variant} weight={weight}>
      An unexpected error occurred. Please try again or contact <ClientServicesLink /> for assistance.
      <br />
      (Error: {code || name ? `${code || name} - ` : ''}
      {Array.isArray(message) ? message.join('; ') : message})
    </MTypography>
  );
};
